import React from 'react';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { findKlarnaClientID } from '../lib/klarnaOnSiteMessaging';
import wrappedWindow from '@reverbdotcom/commons/src/window_wrapper';

export function useKlarnaMessagingEmbed() {
  const { countryCode } = useUser();

  React.useEffect(() => {
    loadKlarnaEmbed({ countryCode });
  }, [countryCode]);

  React.useLayoutEffect(() => {
    window.Klarna?.OnsiteMessaging?.refresh();
  });
}

export function loadKlarnaEmbed({ countryCode, document = wrappedWindow.document }: {
  countryCode: string,
  document?: Document,
}) {
  const clientId = findKlarnaClientID(countryCode);
  if (!clientId) {
    return;
  }

  const script = findOrReplaceScript({ id: '__klarna-osm', document });

  function addData(key: string, value: string) {
    script.dataset[key] = value;
  }

  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://osm.klarnaservices.com/lib.js';

  addData('environment', 'production');
  addData('clientId', clientId);

  document.body.appendChild(script);
}

function findOrReplaceScript({ id, document }: { id: string, document: Document }) {
  const existingScript = document.getElementById(id) as HTMLScriptElement;
  if (existingScript) {
    return existingScript;
  }

  const script = document.createElement('script');
  script.id = id;

  return script;
}
